export default __webpack_public_path__ + "media/images/big-w-70f302c28e0d986ea0a252b9c0b1082a.svg";